import { styled as i } from "@mui/material";
const p = i("div")`
  display: flex;
  gap: 16px;

  & > * {
    flex: 1;
    min-width: 0;
  }
`, a = i("div")(({ theme: i2 }) => `
  display: flex;
  gap: ${i2.spacing(2)};
`);
export {
  p as Row,
  a as RowCheckbox
};
//# sourceMappingURL=styled.js.map
